<template>
  <div class="div" v-loading="loading">
    <!-- <div class="title">资产信息</div> -->
    <div class="div-top">
      <el-button
        icon="el-icon-minus"
        type="danger"
        @click="handleDetele(selectedRows)"
        :disabled="selectedRows.length === 0"
        >删除</el-button
      >
      <!--      <el-input-->
      <!--          v-model="searchData.Keyword"-->
      <!--          clearable-->
      <!--          placeholder="请输入资产信息名称"-->
      <!--          style="width: 300px; margin-left: 10px"-->
      <!--      ></el-input>-->
      <span style="margin-left: 10px">年月</span>
      <el-date-picker
        style="margin-left: 10px"
        v-model="searchData.Keyword"
        type="month"
        value-format="yyyyMM"
        placeholder="选择月"
      >
      </el-date-picker>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      >

      <el-button icon="el-icon-plus" type="primary" @click="handleAdd"
        >计提折旧</el-button
      >
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 40px)"
        @selection-change="handleSelect"
      >
        <el-table-column label="" width="50" type="selection">
        </el-table-column>
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>

        <!-- <el-table-column label="仓库" align="center" prop="StorIdName"> </el-table-column> -->
        <el-table-column
          label="折旧年月"
          width="160"
          align="center"
          prop="iYearMonth"
          sortable
        >
        </el-table-column>
        <el-table-column
          label="折旧金额"
          width="160"
          align="right"
          prop="DepreciationAmount"
          sortable
        >
          <template slot-scope="scope">
            {{ $tools.momenyFormat(scope.row.DepreciationAmount, 2) }}
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center" prop="Remark">
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)"
              >查看</el-button
            >
            <el-button
              type="text"
              @click="handleDetele([scope.row])"
              style="color: #f78989"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <EditForm ref="EditForm" @success="handleSearch" />
  </div>
</template>
<script>
import EditForm from './EditForm'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      searchData: {
        Condition: 'iYearMonth',
        Keyword: '',
      },
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
    }
  },
  props: {},
  components: { EditForm },
  methods: {
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/AM/AM_AssetDepreciation/GetDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
          Search: {
            ...this.searchData,
            Type: this.AssetTreeSeacrh || '',
          },
        })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.tableData = resJson.Data
            this.pagination.total = resJson.Total
            this.$nextTick(() => {
              if (this.$refs.table) {
                this.$refs.table.clearSelection()
              }
            })
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      console.log(this.searchData.Keyword)
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      if (this.searchData.Keyword === '') {
        this.$notify.warning('请选择年月')
        return
      }
      this.$refs.EditForm.openForm(
        '新建计提折旧',
        null,
        this.searchData.Keyword
      )
    },
    handleDetele(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将永久删除该资产信息, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post('/AM/AM_AssetDepreciation/DeleteData', ids)
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('删除成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleEdit(row) {
      this.$refs.EditForm.openForm(
        '编辑资产信息',
        row.Id,
        this.searchData.Keyword
      )
    },
  },
  mounted() {},
  created() {
    this.getDataList()
  },
  computed: {
    ...mapState(['AssetTreeSeacrh']),
  },
  watch: {
    AssetTreeSeacrh() {
      this.handleSearch()
    },
  },
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
</style>
